<div class="w-full">
  <h2 class="qaroni-title my-4 w-full text-center">
    <ng-content />
  </h2>
</div>
